import AngleLeft from '@components/Icons/AngleLeft.jsx'
import AngleRight from '@components/Icons/AngleRight.jsx'

const CarouselNav = ({ showPrev, showNext, movePrev, moveNext }) => {
  return (
    <div className='carousel-nav flex gap-3 mb-2'>
      <div
        className={`angle-left rounded-full bg-[#f8f8f8] p-2 w-12 h-12 flex items-center justify-center hover:bg-[#f4f4f4] ${
          !showPrev ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        }`}
        onClick={showPrev ? movePrev : undefined}
        aria-disabled={!showPrev}
      >
        <AngleLeft width='w-[10px]' />
      </div>
      <div
        className={`angle-right rounded-full bg-[#f8f8f8] p-2 w-12 h-12 flex items-center justify-center hover:bg-[#f4f4f4] ${
          !showNext ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        }`}
        onClick={showNext ? moveNext : undefined}
        aria-disabled={!showNext}
      >
        <AngleRight width='w-[10px]' />
      </div>
    </div>
  );
};

export default CarouselNav;
